import { Select, SelectItem, SelectContent, SelectTrigger, SelectValue } from "@/components/ui/select";
import { provincesSimplified } from "@/constants/provinces";
import { PaginatedTariffsQueryVariables } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { usePaginationState, updatePaginationState } from "@/store/paginationStore";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables: PaginatedTariffsQueryVariables) => void;
  onReset?: (_resetFn: () => void) => void;
}

function TariffsProvinceDropdown(props: Props) {
  const { displayAmount, handleSubmitClick, onReset } = props;
  const { t } = useTranslation(["translation"]);

  const paginationState = usePaginationState("paginatedTariffs");
  const { filters: { province } } = paginationState as any;

  // Track the selected province, default to "all"
  const [selectedProvince, setSelectedProvince] = useState<string>(province || "all");

  function onValueChange(value: string) {
    setSelectedProvince(value);

    const updatedFilters = {
      ...paginationState.filters,
      province: value === "all" ? null : value,
    };

    // Update pagination state
    updatePaginationState({
      paginatedTariffs: {
        filters: updatedFilters
      }
    });

    handleSubmitClick({
      first: displayAmount,
      filters: updatedFilters,
    });
  }

  useEffect(() => {
    setSelectedProvince(province || "all");
  }, [province]);

  // Expose reset function to parent component
  useEffect(() => {
    if (onReset) {
      onReset(() => {
        setSelectedProvince("all");
      });
    }
  }, [onReset]);

  return (
    <Select value={selectedProvince} onValueChange={onValueChange}>
      <SelectTrigger className="w-fit">
        <SelectValue placeholder={t("settings.configurations.selectprovince")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t("settings.configurations.allprovinces")}</SelectItem>
        {provincesSimplified.map((province) => (
          <SelectItem key={province.code} value={province.code}>
            {province.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default TariffsProvinceDropdown;
